// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ho_oh: PokeData = {
  "id": 250,
  "name": "ho-oh",
  "height": 38,
  "weight": 1990,
  "base_experience": 306,
  "types": [
    PokeType.FIRE,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "recover",
    "fire-blast",
    "swift",
    "sky-attack",
    "safeguard",
    "sacred-fire",
    "sunny-day",
    "ancient-power",
    "future-sight",
    "weather-ball",
    "overheat",
    "extrasensory",
    "calm-mind",
    "natural-gift",
    "punishment",
    "brave-bird",
    "burn-up",
    "life-dew"
  ],
  "moves": [
    "gust",
    "sky-attack",
    "sunny-day",
    "ancient-power",
    "future-sight",
    "calm-mind",
    "brave-bird",
    "life-dew",
    "fire-spin",
    "acrobatics",
    "chatter",
    "air-slash",
    "ember"
  ],
  "evolution_chain": {
    "id": 128,
    "item": null,
    "species": [
      {
        "name": "ho-oh",
        "order": 275,
        "types": [
          PokeType.FIRE,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 137,
    "speed": 108,
    "ability_power": 156
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
